export const isNumberValue = (value: string) =>
  new RegExp(/^(?:[1-9]\d*|0)?(?:\.\d+)?$/u, 'u').test(value);

export const isBooleanValue = (value: boolean | number | string) =>
  value === 'Positive' ||
  value === 'true' ||
  value === 'Negative' ||
  value === 'false' ||
  typeof value === 'boolean';
